import { useState, useEffect } from "react";
import { apiGetMatches } from "../api";

let cachedResult = null;

export function useTournamentComplete() {
  const [complete, setComplete] = useState(cachedResult);

  useEffect(() => {
    if (cachedResult !== null) return;
    apiGetMatches().then((matches) => {
      const done = matches.length > 0 && matches.every((m) => m.status === "COMPLETED");
      cachedResult = done;
      setComplete(done);
    }).catch(() => {
      setComplete(false);
    });
  }, []);

  return complete ?? false;
}
